module.exports = __webpack_public_path__ + "img/W-G03.40bb887d.jpg";